// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"46":"cdd88563","52":"cdd88563","447":"cdd88563","552":"cdd88563","599":"cdd88563","730":"cdd88563","753":"cdd88563","806":"cdd88563","918":"cdd88563","929":"cdd88563"}[chunkId] + ".chunk.css";
};